const KNOWN = new Set(["refrigerator", "washer", "dryer", "dishwasher", "range-oven"]);

// Old WooCommerce URLs → closest current store page (served as 301 to the prerenderer).
export function legacyTarget(pathname) {
  const m = (pathname || "").match(/^\/product-category\/([a-z0-9-]+)-parts(\/|$)/i);
  if (m && KNOWN.has(m[1].toLowerCase())) return `/en/${m[1].toLowerCase()}-parts/`;
  return "/en/";
}
